export default __webpack_public_path__ + "locales/ja-JP/Payments.json?hash=871a118468237dd7009f5dcbe0fcd373";